(function () {
    function dateTimeFilter(LocalisationService) {
        return function (input) {
            if (!input) {
                return input;
            }

            return LocalisationService.formatToFullDateTime(input);
        }
    }
    angular
        .module('dashboard')
        .filter('customDateTime', [ 'LocalisationService', dateTimeFilter ])
})();
